import * as turf from '@turf/turf'

function mapboxBoundsToBbox(bounds) {
  return [
    bounds.getWest(),
    bounds.getSouth(),
    bounds.getEast(),
    bounds.getNorth()
  ]
}
function pointsWithinBounds(geoJSON, bounds) {
  const bboxPolygon = turf.bboxPolygon(mapboxBoundsToBbox(bounds))
  return turf.pointsWithinPolygon(geoJSON, bboxPolygon)
}
export { pointsWithinBounds }
